<template>
    <div class="drop-zone-container">
        <div class="d-block" @drop="dropHandler" @dragenter="checkDrop" @dragover="checkDrop" @dragleave="leavedrag" :class="{ dragged: check }">
            <label class="font f-s-14 l-h-20 f-w-600 mb-8 color primary">Attachments</label>
            <div>
                <file-item
                    v-for="(file, i) in files"
                    @remove="remove"
                    :key="i"
                    :index="i"
                    :file="file"
                />
            </div>
            <label for="dropzone-file-input" class="drop-zone d-block">
                <span>Add up to {{ maxFile }} files</span>
            </label>
        </div>
        <input ref="file-input" type="file" id="dropzone-file-input" multiple class="dropzone-file-input" @change="fileHandler">
    </div>
</template>

<script>
import FileItem from '~/components/common/input/dropzone/file';

export default {
    components: {
        FileItem,
    },
    props: {
        maxFile: {
            type: [Number, String],
            default: 1,
        },
    },
    data() {
        return {
            check: false,
            files: [],
            maxFileUpload: 3,
        };
    },
    methods: {
        getFiles() {
            return this.files;
        },
        remove(index) {
            this.files.splice(index, 1);
        },
        fileHandler() {
            if (this.maxUpload()) return;

            const ref = this.$refs['file-input'];
            for (let n = 0; n < ref.files.length; n++) {
                if (this.maxUpload()) return;
                this.files.push(ref.files[n]);
            }
        },
        dropHandler(e) {
            e.preventDefault();
            if (this.maxUpload()) return;

            if (e.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                for (let i = 0; i < e.dataTransfer.items.length; i++) {
                    if (this.maxUpload()) return;
                    // If dropped items aren't files, reject them
                    if (e.dataTransfer.items[i].kind === 'file') {
                        const file = e.dataTransfer.items[i].getAsFile();
                        this.files.push(file);
                    }
                }
            } else {
                // Use DataTransfer interface to access the file(s)
                for (let n = 0; n < e.dataTransfer.files.length; n++) {
                    if (this.maxUpload()) return;
                    this.files.push(e.dataTransfer.files[n].getAsFile());
                }
            }
        },
        maxUpload() {
            return this.files.length >= this.maxFileUpload;
        },
        checkDrop(e) {
            this.check = true;
            e.preventDefault();
        },
        leavedrag(e) {
            this.check = false;
            e.preventDefault();
        },
    },
};
</script>

<style lang="scss" scoped>
.drop-zone-container {
    .drop-zone {
        border: 1px dashed #eeeeee;
        border-width: 0.142857rem;
        border-radius: 5px;
        text-align: center;
        padding: 10px;
        &:hover {
            border-color: #cccccc;
        }
    }
    .dropzone-file-input {
        display: none;
    }
}
</style>
